import { LoaderActions } from '@store/loaders'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { InternalTemplatesActions, type TemplatesActions } from '../actions'
import type { TemplateItem } from '../types'

// The two lists come from two endpoints on purpose: the Octopus gallery is
// public and always there, the own list needs the newer backend. One failing
// must not blank the other — and neither failure is worth a toast: the section
// simply shows what it has, the way the rest of the dashboard does.
export function* fetchTemplates({
  payload: { workspaceId },
}: ReturnType<typeof TemplatesActions.fetch>) {
  yield put(LoaderActions.set('templates_fetch'))

  let shared: TemplateItem[] = []
  let own: TemplateItem[] = []

  try {
    shared = yield call(API.Projects.templates)
  } catch (error) {
    console.error('Failed to load Octopus templates', error)
  }

  try {
    own =
      workspaceId === PERSONAL_WORKSPACE_ID
        ? yield call(API.Template.listMine)
        : yield call(API.Template.list, workspaceId)
  } catch (error) {
    console.error('Failed to load templates', error)
  }

  yield put(InternalTemplatesActions.set({ workspaceId, own, shared }))
  yield put(LoaderActions.unset('templates_fetch'))
}
